import { useState } from 'react';
import api from 'api';
import 'styles/quotepdfpreview.css';

const GetPDF = (
    {
        quoteid,
    }
) => {

    const [ showPreview, setShowPreview ] = useState(false); // popup de prévisualisation
    const [ pdfUrl, setPdfUrl ] = useState(null); // url du blob pdf généré
    const [ fileName, setFileName ] = useState('document.pdf'); // nom du fichier pour le téléchargement
    const [ quote, setQuote ] = useState(null); // infos du devis (client, email, évènement)

    // récupère le pdf du devis et prépare son url de prévisualisation/téléchargement
    const fetchPdf = () => {
        api.get(`pdf/quote/${quoteid}`, { responseType: 'blob' })
        .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            var name = 'document.pdf'; // Nom par défaut
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                if (fileNameMatch && fileNameMatch.length > 1) {
                    name = fileNameMatch[1];
                }
            }
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            setFileName(name);
            setPdfUrl(URL.createObjectURL(pdfBlob));
        });
    };

    // ouvre le popup de prévisualisation et charge le pdf + les infos du devis
    const handleClickQuote = () => {
        setShowPreview(true);
        fetchPdf();
        api.get(`quote/${quoteid}`)
        .then(response => setQuote(response.data));
    };

    // ferme le popup et libère l'url du blob
    const handleClose = () => {
        setShowPreview(false);
        if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        setPdfUrl(null);
        setQuote(null);
    };

    // télécharge le pdf déjà chargé
    const handleDownload = () => {
        if (!pdfUrl) return;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = fileName;
        link.click();
    };

    // télécharge le pdf (mailto ne permet pas de joindre un fichier) et ouvre le client mail pré-rempli
    const handleEmail = () => {
        handleDownload();
        const to = quote?.email || "";
        const subject = encodeURIComponent(`Devis n°${quoteid}${quote?.event ? " - " + quote.event : ""}`);
        const body = encodeURIComponent(
`Bonjour,

Veuillez trouver ci-joint le devis n°${quoteid}${quote?.event ? ` concernant "${quote.event}"` : ""} (fichier téléchargé : ${fileName}, à joindre manuellement à cet email).

N'hésitez pas à nous contacter pour toute question.

Cordialement,
MEB Son Lumière`
        );
        window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
    };

    return (
        <>
            <div
                className='QuoteLineIcon'
                onClick={handleClickQuote}
            >
                📄
            </div>
            {
                showPreview
                &&
                <div className="QuotePdfPreviewOverlay" onClick={handleClose}>
                    <div className="QuotePdfPreviewPopup" onClick={(e) => e.stopPropagation()}>
                        <div className="QuotePdfPreviewHeader">
                            <span>Devis n°{quoteid}</span>
                            <span className="QuotePdfPreviewClose" onClick={handleClose}>✖</span>
                        </div>
                        <div className="QuotePdfPreviewBody">
                            {
                                pdfUrl
                                ?
                                <object data={pdfUrl} type="application/pdf" className="QuotePdfPreviewFrame">
                                    <div className="QuotePdfPreviewLoading">
                                        Aperçu indisponible dans ce navigateur — <a href={pdfUrl} target="_blank" rel="noreferrer">ouvrir le PDF dans un nouvel onglet</a>.
                                    </div>
                                </object>
                                : <div className="QuotePdfPreviewLoading">Chargement du devis...</div>
                            }
                        </div>
                        <div className="QuotePdfPreviewFooter">
                            <button onClick={handleDownload} disabled={!pdfUrl}>⬇️ Télécharger</button>
                            <button onClick={handleEmail} disabled={!pdfUrl}>✉️ Envoyer par email</button>
                        </div>
                        {
                            quote
                            &&
                            !quote.email
                            &&
                            <div className="QuotePdfPreviewWarning">Aucun email enregistré pour ce client — pensez à le renseigner dans le devis.</div>
                        }
                    </div>
                </div>
            }
        </>
    )

};

export default GetPDF;
